(function() {
  'use strict';

  function initHeroParallax() {
    var heroBackgroundImage = document.getElementById('heroBackgroundImage');

    if (!heroBackgroundImage) {
      return;
    }

    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset || window.scrollY;
      var offset = scrollY * 0.4;

      heroBackgroundImage.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroParallax);
  } else {
    initHeroParallax();
  }
})();
